<div
    class="systemconfig--wrapper"
    data-testid="t-systemconfig-div-1752672977568-49"
>
    <div
        class="content-box"
        data-testid="t-systemconfig-div-1752672977568-48"
    >
        <div
            class="row g-3"
            data-testid="t-systemconfig-div-1752672977568-47"
        >
            <div
                class="col-12 scrolling-area--standalone"
                data-testid="t-systemconfig-div-1752672977568-46"
            >
                <div
                    class="add--header"
                    data-testid="t-systemconfig-div-1752672977568-1"
                >
                    <span
                        class="h5"
                        data-testid="t-systemconfig-span-1752672977568-1"
                        >{{ 'mws.systemconfiguration' | i18n }}:</span
                    >
                </div>

                <div
                    class="content-box"
                    data-testid="t-systemconfig-div-1752672977568-45"
                >
                    <div
                        class="step-bar"
                        data-testid="t-systemconfig-div-1752672977568-2"
                    >
                        <ul data-testid="t-systemconfig-ul-1752672977568-1">
                            <li
                                class="progress-step"
                                [ngClass]="step === 1 ? 'active' : step > 1 ? 'done' : ''"
                                data-testid="t-systemconfig-li-1752672977568-1"
                            >
                                @if (step <= 1) {
                                    <span data-testid="t-systemconfig-span-1752672977568-2"> 1. </span>
                                }
                                @if (step > 1) {
                                    <span data-testid="t-systemconfig-span-1752672977568-3">
                                        <i
                                            class="oc-general-check"
                                            data-testid="t-systemconfig-i-1752672977568-1"
                                        ></i>
                                    </span>
                                }
                            </li>

                            <li
                                class="progress-step"
                                [ngClass]="step === 2 ? 'active' : step > 2 ? 'done' : ''"
                                data-testid="t-systemconfig-li-1752672977568-2"
                            >
                                @if (step <= 2) {
                                    <span data-testid="t-systemconfig-span-1752672977568-4"> 2. </span>
                                }
                                @if (step > 2) {
                                    <span data-testid="t-systemconfig-span-1752672977568-5">
                                        <i
                                            class="oc-general-check"
                                            data-testid="t-systemconfig-i-1752672977568-2"
                                        ></i>
                                    </span>
                                }
                            </li>

                            <li
                                class="progress-step"
                                [ngClass]="step === 3 ? 'done' : ''"
                                data-testid="t-systemconfig-li-1752672977568-3"
                            >
                                @if (step < 3) {
                                    <span data-testid="t-systemconfig-span-1752672977568-6"> 3. </span>
                                }
                                @if (step === 3) {
                                    <span data-testid="t-systemconfig-span-1752672977568-7">
                                        <i
                                            class="oc-general-check"
                                            data-testid="t-systemconfig-i-1752672977568-3"
                                        ></i>
                                    </span>
                                }
                            </li>
                        </ul>
                    </div>
                    @if (step === 1) {
                        <div
                            id="step-1"
                            data-testid="t-systemconfig-div-1752672977568-12"
                        >
                            <div
                                class="add--header"
                                data-testid="t-systemconfig-div-1752672977568-4"
                            >
                                <div
                                    class="col"
                                    data-testid="t-systemconfig-div-1752672977568-3"
                                >
                                    <span
                                        class="h5"
                                        data-testid="t-systemconfig-span-1752672977568-8"
                                        >{{ 'mws.systemconfiguration.step1' | i18n }}</span
                                    >
                                </div>
                            </div>
                            <label
                                class="form-label"
                                data-testid="t-systemconfig-label-1752672977568-1"
                                >{{ 'mws.systemconfiguration.step1.headline' | i18n }}
                            </label>
                            <div
                                class="button-wrapper"
                                data-testid="t-systemconfig-div-1752672977568-5"
                            >
                                <button
                                    class="btn btn-primary w-100"
                                    (click)="startLoading()"
                                    [disabled]="isLoading"
                                    data-testid="t-systemconfig-button-1752672977568-1"
                                >
                                    {{ 'mws.systemconfiguration.button.start' | i18n }}
                                </button>
                            </div>
                            @if (msgDbLoading && msgDbLoading.length > 0) {
                                <div
                                    class="my-3 alert alert-success"
                                    data-testid="t-systemconfig-div-1752672977568-6"
                                >
                                    {{ msgDbLoading }}
                                </div>
                            }
                            <!-- START technische Ausgaben -->
                            @if (isLoading && (!systemconfigService.stateResults || systemconfigService.stateResults.length === 0)) {
                                <div
                                    class="alert alert-info"
                                    data-testid="t-systemconfig-div-1752672977568-7"
                                >
                                    File-Upload in progress
                                </div>
                            }
                            @if (isLoading && systemconfigService.stateResults && systemconfigService.stateResults.length > 0) {
                                <div data-testid="t-systemconfig-div-1752672977568-11">
                                    @for (stateResult of systemconfigService.stateResults; track stateResult) {
                                        <div
                                            class="row g-3"
                                            data-testid="t-systemconfig-div-1752672977568-10"
                                        >
                                            <div
                                                class="col-4"
                                                data-testid="t-systemconfig-div-1752672977568-8"
                                            >
                                                {{ stateResult.stateNew }}
                                            </div>
                                            <div
                                                class="col-8"
                                                data-testid="t-systemconfig-div-1752672977568-9"
                                            >
                                                {{ stateResult.stateMsg }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            <!-- ENDE technische Ausgaben -->
                        </div>
                    }
                    @if (step === 2) {
                        <div
                            id="step-2"
                            data-testid="t-systemconfig-div-1752672977568-36"
                        >
                            <div
                                class="add--header"
                                data-testid="t-systemconfig-div-1752672977568-14"
                            >
                                <div
                                    class="col"
                                    data-testid="t-systemconfig-div-1752672977568-13"
                                >
                                    <span
                                        class="h5"
                                        data-testid="t-systemconfig-span-1752672977568-9"
                                        >{{ 'mws.systemconfiguration.step2' | i18n }}</span
                                    >
                                </div>
                            </div>
                            <form
                                [formGroup]="systemSetupForm"
                                class="customer-form"
                                (ngSubmit)="saveSystemSetupData()"
                                data-testid="t-systemconfig-form-1752672977568-1"
                            >
                                <div
                                    class="row g-3"
                                    data-testid="t-systemconfig-div-1752672977568-27"
                                >
                                    <!-- -->
                                    <div
                                        class="col-12 col-md-4"
                                        data-testid="t-systemconfig-div-1752672977568-16"
                                    >
                                        <div
                                            class="form-group"
                                            data-testid="t-systemconfig-div-1752672977568-15"
                                        >
                                            <label data-testid="t-systemconfig-label-1752672977568-2"
                                                >{{ 'mws.systemconfiguration.step2.mandatorname' | i18n }} *:
                                            </label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="name"
                                                formControlName="name"
                                                placeholder="Name"
                                                data-testid="t-systemconfig-input-1752672977568-1"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col-12 col-md-4"
                                        data-testid="t-systemconfig-div-1752672977568-21"
                                    >
                                        <div
                                            class="form-group"
                                            data-testid="t-systemconfig-div-1752672977568-20"
                                        >
                                            <label data-testid="t-systemconfig-label-1752672977568-3"
                                                >{{ 'mws.systemconfiguration.step2.passwordadmin' | i18n }} *:</label
                                            >
                                            <div
                                                class="input-group"
                                                data-testid="t-systemconfig-div-1752672977568-19"
                                            >
                                                <input
                                                    [type]="passwordAdminType ? 'text' : 'password'"
                                                    #passwordAdmin
                                                    id="passwordAdmin"
                                                    formControlName="passwordAdmin"
                                                    class="form-control"
                                                    placeholder="{{ 'mws.systemconfiguration.step2.passwordadmin' | i18n }}"
                                                    data-testid="t-systemconfig-input-1752672977568-2"
                                                />
                                                <div
                                                    class="input-group-append"
                                                    data-testid="t-systemconfig-div-1752672977568-18"
                                                >
                                                    <div
                                                        class="input-group-text with-icon"
                                                        (click)="togglePasswordAdminType()"
                                                        data-testid="t-systemconfig-div-1752672977568-17"
                                                    >
                                                        <i
                                                            class="oc-eye"
                                                            [ngClass]="{ 'oc-eye-slash': passwordAdminType, 'oc-eye': !passwordAdminType }"
                                                            data-testid="t-systemconfig-i-1752672977568-4"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="col-12 col-md-4"
                                        data-testid="t-systemconfig-div-1752672977568-26"
                                    >
                                        <div
                                            class="form-group"
                                            data-testid="t-systemconfig-div-1752672977568-25"
                                        >
                                            <label data-testid="t-systemconfig-label-1752672977568-4"
                                                >{{ 'mws.systemconfiguration.step2.passwordocadmin' | i18n }} *:
                                            </label>
                                            <div
                                                class="input-group"
                                                data-testid="t-systemconfig-div-1752672977568-24"
                                            >
                                                <input
                                                    [type]="passwordOcAdminType ? 'text' : 'password'"
                                                    #passwordOcAdmin
                                                    id="passwordOcAdmin"
                                                    formControlName="passwordOcAdmin"
                                                    class="form-control"
                                                    placeholder="{{ 'mws.systemconfiguration.step2.passwordocadmin' | i18n }}"
                                                    data-testid="t-systemconfig-input-1752672977568-3"
                                                />
                                                <div
                                                    class="input-group-append"
                                                    data-testid="t-systemconfig-div-1752672977568-23"
                                                >
                                                    <div
                                                        class="input-group-text with-icon"
                                                        (click)="togglePasswordOcAdminType()"
                                                        data-testid="t-systemconfig-div-1752672977568-22"
                                                    >
                                                        <i
                                                            class="oc-eye"
                                                            [class.oc-eye-slash]="passwordOcAdminType"
                                                            [class.oc-eye]="!passwordOcAdminType"
                                                            data-testid="t-systemconfig-i-1752672977568-5"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="row g-3"
                                    data-testid="t-systemconfig-div-1752672977568-34"
                                >
                                    <!-- -->
                                    <div
                                        class="col-12 col-md-4"
                                        data-testid="t-systemconfig-div-1752672977568-29"
                                    >
                                        <div
                                            class="form-group"
                                            data-testid="t-systemconfig-div-1752672977568-28"
                                        >
                                            <label data-testid="t-systemconfig-label-1752672977568-5">{{ 'prompt.language' | i18n }}*: </label>
                                            <select
                                                class="form-select"
                                                id="languageId"
                                                formControlName="languageId"
                                                data-testid="t-systemconfig-select-1752672977568-1"
                                            >
                                                @for (l of environmentService.languageList; track l) {
                                                    <option
                                                        [value]="l.id"
                                                        data-testid="t-systemconfig-option-1752672977568-1"
                                                    >
                                                        {{ l.descr }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div
                                        class="col-12 col-md-4"
                                        data-testid="t-systemconfig-div-1752672977568-31"
                                    >
                                        <div
                                            class="form-group"
                                            data-testid="t-systemconfig-div-1752672977568-30"
                                        >
                                            <label data-testid="t-systemconfig-label-1752672977568-6">{{ 'mws.countryvariant' | i18n }}*:</label>
                                            <select
                                                class="form-select"
                                                id="countryId"
                                                formControlName="countryId"
                                                data-testid="t-systemconfig-select-1752672977568-2"
                                            >
                                                <option
                                                    [value]="null"
                                                    data-testid="t-systemconfig-option-1752672977568-2"
                                                >
                                                    {{ 'mws.pleasechoose' | i18n }}
                                                </option>
                                                @for (country of environmentService.countryList; track country) {
                                                    <option
                                                        [value]="country.id"
                                                        data-testid="t-systemconfig-option-1752672977568-3"
                                                    >
                                                        {{ country.descr }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div
                                        class="col-12 col-md-4"
                                        data-testid="t-systemconfig-div-1752672977568-33"
                                    >
                                        <div
                                            class="form-group"
                                            data-testid="t-systemconfig-div-1752672977568-32"
                                        >
                                            <label data-testid="t-systemconfig-label-1752672977568-7">{{ 'mws.currency' | i18n }}*: </label>
                                            <select
                                                class="form-select"
                                                formControlName="currencyId"
                                                data-testid="t-systemconfig-select-1752672977568-3"
                                            >
                                                <option
                                                    [value]="null"
                                                    data-testid="t-systemconfig-option-1752672977568-4"
                                                >
                                                    {{ 'mws.pleasechoose' | i18n }}
                                                </option>
                                                @for (cur of environmentService.currencyList; track cur) {
                                                    <option
                                                        [value]="cur.id"
                                                        data-testid="t-systemconfig-option-1752672977568-5"
                                                    >
                                                        {{ cur.descr }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="button-wrapper"
                                    data-testid="t-systemconfig-div-1752672977568-35"
                                >
                                    <button
                                        [disabled]="!systemSetupForm.get('changed').touched"
                                        type="button"
                                        (click)="initFormValues()"
                                        [attr.aria-label]="'button.discard' | i18n"
                                        class="btn btn-danger"
                                        data-testid="t-systemconfig-button-1752672977568-2"
                                    >
                                        <i
                                            class="oc-general-cancel"
                                            data-testid="t-systemconfig-i-1752672977568-6"
                                        ></i>
                                    </button>
                                    <button
                                        [disabled]="!systemSetupForm.get('changed').touched"
                                        type="submit"
                                        [attr.aria-label]="'button.check' | i18n"
                                        class="btn btn-success"
                                        data-testid="t-systemconfig-button-1752672977568-3"
                                    >
                                        <i
                                            class="oc-general-check"
                                            data-testid="t-systemconfig-i-1752672977568-7"
                                        ></i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    }
                    @if (step === 3) {
                        <div
                            id="step-3"
                            data-testid="t-systemconfig-div-1752672977568-44"
                        >
                            <div
                                class="add--header"
                                data-testid="t-systemconfig-div-1752672977568-38"
                            >
                                <div
                                    class="col"
                                    data-testid="t-systemconfig-div-1752672977568-37"
                                >
                                    <span
                                        class="h5"
                                        data-testid="t-systemconfig-span-1752672977568-10"
                                        >{{ 'mws.systemconfiguration.step3' | i18n }} :
                                    </span>
                                </div>
                            </div>
                            <div
                                class="add--header"
                                data-testid="t-systemconfig-div-1752672977568-40"
                            >
                                <div
                                    class="col"
                                    data-testid="t-systemconfig-div-1752672977568-39"
                                >
                                    {{ 'mws.systemconfiguration.step3.finish' | i18n }}
                                </div>
                            </div>
                            <div
                                class="col-12 col-md-6 col-lg-4"
                                data-testid="t-systemconfig-div-1752672977568-43"
                            >
                                <!-- Ausgabe der Systemconfig als Info -->
                                <div
                                    class="row"
                                    data-testid="t-systemconfig-div-1762851932780-3"
                                >
                                    <div
                                        class="col"
                                        data-testid="t-systemconfig-div-1762851932780-2"
                                    >
                                        <div
                                            class="alert alert-info mb-3"
                                            data-testid="t-systemconfig-div-1762851932780-1"
                                        >
                                            <strong
                                                class="d-block alert-heading"
                                                data-testid="t-systemconfig-strong-1762851932780-1"
                                                >{{ 'prompt.note' | i18n }}</strong
                                            >
                                            <span data-testid="t-systemconfig-span-1762851932780-1">
                                                {{ systemconfigResponse | json }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="row g-0"
                                    data-testid="t-systemconfig-div-1752672977568-42"
                                >
                                    <div
                                        class="col"
                                        data-testid="t-systemconfig-div-1752672977568-41"
                                    >
                                        <button
                                            class="btn btn-primary w-100"
                                            (click)="logout()"
                                            data-testid="t-systemconfig-button-1752672977568-4"
                                        >
                                            {{ 'mws.navbar.logout' | i18n }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
